import { render } from "./FooterBar.vue?vue&type=template&id=6670ecd3&scoped=true"
import script from "./FooterBar.vue?vue&type=script&lang=js"
export * from "./FooterBar.vue?vue&type=script&lang=js"

import "./FooterBar.vue?vue&type=style&index=0&id=6670ecd3&scoped=true&lang=scss"

import exportComponent from "/Users/cogliawho/Documents/WEBDEV/epicentric-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6670ecd3"]])

export default __exports__